import React, { useEffect } from 'react'
import { AnimatePresence, motion } from 'framer-motion'
import { useRouter } from 'next/router'
import checkAuthSSR from '@/utils/auth-check'
import Head from 'next/head'
import { QueryClient, QueryClientProvider } from 'react-query'
import { RecoilRoot } from 'recoil'
import TopNav from '@/components/layouts/app/TopNav'
import Footer from '@/components/optypes/app/Footer.js'

const AppLayout = ({ children }) => {
  const router = useRouter()

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: false,
      },
    },
  })

  // Search hotkey (ctrl+j)
  useEffect(() => {
    const handleEsc = e => {
      if (e.keyCode == 74 && e.ctrlKey) {
        var link = document.getElementById('searchModal')
        link.click()
      }
    }
    window.addEventListener('keydown', handleEsc)
    return () => {
      window.removeEventListener('keydown', handleEsc)
    }
  }, [])

  return (
    <QueryClientProvider client={queryClient}>
      <Head>
        <meta
          name="viewport"
          content="initial-scale=1, viewport-fit=cover, user-scalable=no"
        />
        {process.env.NODE_ENV === 'production' && (
          <script
            dangerouslySetInnerHTML={{
              __html: `
            window.fwSettings={
              'widget_id':67000002020
              };
              !function(){if("function"!=typeof window.FreshworksWidget){var n=function(){n.q.push(arguments)};n.q=[],window.FreshworksWidget=n}}()
        `,
            }}
          />
        )}
        {process.env.NODE_ENV === 'production' && (
          <script
            type="text/javascript"
            src="https://widget.freshworks.com/widgets/67000002020.js"
            async
            defer
          ></script>
        )}

{/*process.env.NODE_ENV === 'production' && (
          <script id="ze-snippet"src="https://static.zdassets.com/ekr/snippet.js?key=733d08bf-a97b-420c-b144-c934c1be2132"></script>
        )*/}
        <link
          rel="apple-touch-icon"
          sizes="57x57"
          href="/apple-touch-icon-57x57.png"
        />
        <link
          rel="apple-touch-icon"
          sizes="72x72"
          href="/apple-touch-icon-72x72.png"
        />
        <link
          rel="apple-touch-icon"
          sizes="76x76"
          href="/apple-touch-icon-76x76.png"
        />
        <link
          rel="apple-touch-icon"
          sizes="114x114"
          href="/apple-touch-icon-114x114.png"
        />
        <link
          rel="apple-touch-icon"
          sizes="120x120"
          href="/apple-touch-icon-120x120.png"
        />
        <link
          rel="apple-touch-icon"
          sizes="144x144"
          href="/apple-touch-icon-144x144.png"
        />
        <link
          rel="apple-touch-icon"
          sizes="152x152"
          href="/apple-touch-icon-152x152.png"
        />
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href="/apple-touch-icon-180x180.png"
        />
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href="/apple-touch-icon.png"
        />
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href="/apple-touch-icon.png"
        />
        <link rel="shortcut icon" href="/favicon.ico" />
      </Head>

      <RecoilRoot>
        <div className="flex bg-gray-50 appBG min-h-screen w-full">
          <div className="flex flex-col w-0 flex-1 ">
            <TopNav />

            <main className="flex-1 relative  pb-10 focus:outline-none">
              {/* <AnimatePresence exitBeforeEnter>
                <motion.div
                  key={router.route}
                  initial="hidden"
                  animate="visible"
                  exit="pageExit"
                  variants={{
                    hidden: {
                      opacity: 0,
                      y: 5,
                    },
                    visible: {
                      opacity: 1,
                      y: 0,
                    },
                    pageExit: {
                      scale: 0.99,
                      opacity: 0,
                    },
                  }}
                >
                  <div className="">{children}</div>
                </motion.div>
              </AnimatePresence> */}
              {children}
              <Footer />
            </main>
          </div>
        </div>
      </RecoilRoot>
    </QueryClientProvider>
  )
}

export default AppLayout

export async function getServerSideProps(context) {
  const user = await checkAuthSSR(context)

  if (!user) {
    return {
      redirect: {
        permanent: false,
        destination: '/login',
      },
    }
  }

  return {
    props: {
      user,
    },
  }
}
